import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuthStore } from '@store/authStore';
import { usePermissions } from '@hooks/usePermissions';
import type { PermissionKey } from '@/types';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return <>{children}</>;
}

export function PermissionRoute({
  children,
  permission,
}: {
  children: ReactNode;
  permission: PermissionKey | PermissionKey[];
}) {
  const { can } = usePermissions();
  if (!can(permission)) return <Navigate to="/forbidden" replace />;
  return <>{children}</>;
}

export function RoleRoute({ children, roles }: { children: ReactNode; roles: string[] }) {
  const { is } = usePermissions();
  if (!is(roles)) return <Navigate to="/forbidden" replace />;
  return <>{children}</>;
}
